import * as Sentry from "@sentry/react";

// Initialize Sentry - sadece production ortamında çalışır
const isLocalHost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

if (!import.meta.env.DEV && !isLocalHost) {
  Sentry.init({
    dsn: "https://212190c0a67d74df9da14fc74b8dd930@o4509394567102464.ingest.de.sentry.io/4510006714171473",

    // Adds more context data to events (IP address, cookies, user, etc.)
    sendDefaultPii: true,

    // Configure Session Replay
    replaysSessionSampleRate: 1,
    replaysOnErrorSampleRate: 1,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.feedbackIntegration({
        // Additional SDK configuration goes in here, for example:
        colorScheme: "system",
        isNameRequired: true,
        isEmailRequired: true,
        showBranding: false,
        lang: "tr",
        nameLabel: "Adınız",
        namePlaceHolder: "Adınız",
        emailPlaceholder: "E-posta Adresiniz",
        messagePlaceholder: "Hata Açıklaması",
        messageLabel: "Hata Açıklaması",
        isRequiredLabel: "Zorunlu Alan",
        emailLabel: "E-posta Adresiniz",
        triggerLabel: "Hata Bildir",
        submitButtonLabel: "Hata Raporu Gönder",
        formTitle: "Hata Bildir",
        cancelButtonLabel: "Vazgeç",
        addScreenshotButtonLabel: "Ekran Görüntüsü Ekle",
        removeScreenshotButtonLabel: "Ekran Görüntüsünü Kaldır",
        confirmButtonLabel: "Onayla",
        successMessageText: "Teşekkür ederiz!",
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
        networkDetailAllowUrls: [
          "ikapi.kartalbombe.com.tr",
          /^https:\/\/ikapi\.kartalbombe\.com\.tr/,
        ],
        networkCaptureBodies: true,
        networkDetailDenyUrls: [/^http:\/\/localhost:\d*/],
      }),
    ],

    // Enable tracing
    tracesSampleRate: 1.0,

    // Environment
    environment: import.meta.env.MODE,

    // Release
    release: import.meta.env.VITE_APP_VERSION || "1.0.0",

    // uncomment the line below to enable Spotlight (https://spotlightjs.com)
    // spotlight: import.meta.env.DEV,
  });
}

export default Sentry;
